export default "__VITE_ASSET__1uSL5jRx__"